import { Action, createReducer, on } from '@ngrx/store';
import { cronJobActions } from './cronJob.actions';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { CronJobListResponse } from '../../../api/models';

export interface CronJobState {
  //list
  cronJobList: {
    state: ILoaderActionPayload;
    data?: CronJobListResponse;
  };
}
const initialState: CronJobState = {
  cronJobList: {
    state: {
      value: LoadingState.NONE,
    },
  },
};

const reducer = createReducer(
  initialState,
  // load agents
  on(cronJobActions.loadCronJobList, (state) => ({
    ...state,
    cronJobList: { state: { value: LoadingState.LOADING } },
  })),
  on(cronJobActions.loadCronJobListDone, (state, props) => ({
    ...state,
    cronJobList: { state: props.state, data: props.data },
  })),
  on(cronJobActions.loadCronJobListSetState, (state, props) => ({
    ...state,
    cronJobList: { state: props.state },
  })),
);
export function cronJobReducer(state: CronJobState | undefined, action: Action) {
  return reducer(state, action);
}
